import { render } from "./Sidebar.vue?vue&type=template&id=09976153&scoped=true"
import script from "./Sidebar.js?vue&type=script&lang=js"
export * from "./Sidebar.js?vue&type=script&lang=js"

import "./Sidebar.scss?vue&type=style&index=0&id=09976153&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09976153"]])

export default __exports__